import { projectRequest } from 'store/utils/request';

const minutes = num => num * 60 * 1000;

/* eslint-disable camelcase */
export const uploadCSVRequest = async ({
  uploaded_file,
  name,
  dictionary,
  file_encoding,
  file_separator,
}) => {
  try {
    const data = new FormData();
    data.append('uploaded_file', uploaded_file, uploaded_file.name);
    data.append('name', name);
    data.append('dictionary', dictionary);
    data.append('file_encoding', file_encoding);
    data.append('file_separator', file_separator);

    return await projectRequest.post(`/csv-uploads/`, data, {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
      },
      requestId: 'upload-csv',
      timeout: 60000,
    });
  } catch (error) {
    throw error;
  }
};

export const getCSVRequest = async id => {
  try {
    return await projectRequest.get(`/csv-uploads/${id}/`);
  } catch (error) {
    throw error;
  }
};

export const saveCSVRequest = async id => {
  try {
    return await projectRequest.post(`/csv-uploads/${id}/save/`, null, {
      requestId: 'save-csv',
      timeout: minutes(5),
    });
  } catch (error) {
    throw error;
  }
};
